import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { FieldArray, reduxForm, arrayRemoveAll } from 'redux-form';
import _ from 'lodash';
import cx from 'classnames';
import Button from 'client/components/button/button';
import Translate from 'client/components/translate';
import { saveMembers, saveMembersToApp, updateMembers } from 'client/actions/members';

import RenderMemberFields from './renderMemberFields';

const propTypes = {
  restrictSingle: PropTypes.bool,
  handleSubmit: PropTypes.func,
  numSelected: PropTypes.number.isRequired,
  changeHandler: PropTypes.func,
  saveHandler: PropTypes.func,
  hasSpouse: PropTypes.bool,
  incompleteMember: PropTypes.object,
  visionApp: PropTypes.object.isRequired,
  disableAddMembers: PropTypes.bool,
};

const defaultProps = {
  restrictSingle: false,
  handleSubmit: () => {},
  changeHandler: () => {},
  saveHandler: () => {},
  hasSpouse: false,
  incompleteMember: null,
  disableAddMembers: false,
};

const mapStateToProps = state =>
({
  numSelected: _.filter(_.get(state, 'form.newMemberForm.values.members'), { selected: true }).length,
  user: state.user,
  visionApp: _.find(state.ifpApps, { type: 'vision' }),
});

class RenderNewMembers extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {};
  }

  setSubmitting(state) {
    this.setState({
      isSubmitting: state,
    });
  }

  handleSaveClick = (values, dispatch, props) => {
    if (props.user.isLoggedIn) {
      const { members } = values;
      const updatedMembers = members.map(member => (
        { ...member, user_id: props.user.oid, dob: null }
      ));

      this.setSubmitting(true);
      return props.saveMembers(updatedMembers)
        .then((response) => {
          this.setSubmitting(false);
          // Successful save
          if (response.status === 'SUCCESS') {
            props.changeHandler(false, response.members);
            dispatch(arrayRemoveAll('newMemberForm', 'members'));
            return response;
          }
          // Error on save

          return response;
        });
    }
    // Logged out user
    props.updateMembers(values);
    const checkedMembers = this.props.visionApp.members || [];
    const membersToSave = checkedMembers.concat(values.members);
    props.saveMembersToApp(membersToSave, props.visionApp.app_id, props.user);

    // No previous members on app
    if (!this.props.visionApp.members) {
      return this.props.saveHandler();
    }
    props.changeHandler(false, values.members);
    return dispatch(arrayRemoveAll('newMemberForm', 'members'));
  }

  renderFormButton = () => {
    const { restrictSingle, numSelected } = this.props;
    let translatePath;
    if (numSelected > 0) {
      if (restrictSingle) {
        translatePath = 'common.saveChanges';
      } else {
        translatePath = numSelected === 1 ? 'app.findInsuranceMyself': 'app.findInsurance';
      }
      return (
        <div className="text-center" style={{ padding: '2.5rem 1rem' }}>
          <Button
            className={cx('cta-button', { submitting: this.state.isSubmitting })}
            type="submit">
            <Translate path={translatePath} using={{ num: numSelected }} />
          </Button>
        </div>
      );
    }
    return null;
  }

  render() {
    const { restrictSingle, changeHandler, hasSpouse, incompleteMember, disableAddMembers } = this.props;

    return (
      <form onSubmit={this.props.handleSubmit(this.handleSaveClick)}>
        <FieldArray
          name="members"
          incompleteMember={incompleteMember}
          disableAddMembers={disableAddMembers}
          component={RenderMemberFields}
          restrictSingle={restrictSingle}
          setEditing={changeHandler}
          hasSpouse={hasSpouse} />
        { this.renderFormButton() }
      </form>
    );
  }
}

RenderNewMembers.propTypes = propTypes;
RenderNewMembers.defaultProps = defaultProps;

const decoratedRenderNewMembers = reduxForm({
  form: 'newMemberForm',
  /* This validate seems to be necessary for update_sync_errors
  to happen so that validation happens again on re-add of member */
  validate: () => ({}),
})(RenderNewMembers);

export default connect(mapStateToProps, {
  saveMembers,
  updateMembers,
  saveMembersToApp,
})(decoratedRenderNewMembers);
